
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.scss']
})
export class CustomComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
